import * as React from 'react';

const Check = ({color = '#2D2756'}) => (
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 1.25L4.92387 7.66667L1.41663 4.24444"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Check;
